import SwellTooltip from './SwellTooltip';

export default SwellTooltip;
